import { Activity, PureCustomValue } from "../types";

export const getActivitySkills = (activity: Pick<Activity, "custom_fields">): PureCustomValue[] =>
  activity.custom_fields.find((cf) => cf.type.name === "skills")?.values || [];
